import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationConstants } from 'angular/constants/NotificationConstants';
import { embedded } from '../../../angular/utils/config';
import { UtilService } from '../../../app/_services/util.service';

export type GrowlType = 'danger' | 'success' | 'warning' | 'info';
export type GrowlOptions = {
    delay?: number;
    allowDismiss?: boolean;
    timestamp?: boolean;
    errorCode?: string;
    statusCode?: number;
    element?: string;
    allowHtml?: boolean;
};

@Injectable()
export class Growl {
    constructor(
        private sanitizer: DomSanitizer,
        private utilService: UtilService
    ) {}

    public show(
        text: string,
        type: GrowlType,
        options: GrowlOptions = {}
    ): NotifyReturn {
        const errorCode: string = options.errorCode
            ? 'Error Code: ' + options.errorCode
            : '';
        const statusCode: string = options.statusCode
            ? 'Status Code: ' + options.statusCode
            : '';
        const delay: number =
            options.delay == null
                ? type === 'danger'
                    ? 0
                    : NotificationConstants.duration
                : options.delay;
        const sanitizedText: string = options.allowHtml
            ? this.sanitizer.sanitize(SecurityContext.HTML, text)
            : this.sanitizer.sanitize(
                  SecurityContext.HTML,
                  this.utilService.escapeHtml(text)
              );

        return $.notify(<NotifyOptions>{}, {
            element: options.element || '#growl-container',
            position: null,
            type: type,
            allow_dismiss:
                options.allowDismiss != null ? options.allowDismiss : true,
            newest_on_top: false,
            showProgressbar: delay > 0,
            placement: {
                from: 'top',
                align: 'right'
            },
            animate: {
                enter: 'animated fadeInUp',
                exit: 'animated fadeOutRight'
            },
            offset: {
                x: 20,
                y: embedded ? 20 : 100
            },
            spacing: 10,
            z_index: 9999,
            delay: delay,
            timer: 1000,
            mouse_over: 'pause',
            template: `
<div data-notify="container" class="col-xs-11 col-sm-3 growl alert alert-{0}" role="alert">
    <button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>
    <div class="content">
        ${sanitizedText}<br>
        <span class="all-small-caps">${statusCode}${
            statusCode && errorCode ? ' - ' : ''
        }${errorCode}</span>
    </div>
    <div class="progress" data-notify="progressbar">
        <div class="progress-bar progress-bar-{0} width_0" role="progressbar"></div>
    </div>
</div>`
        });
    }
}

function initGrowlContainer() {
    if (!embedded) return;

    const element = document.getElementById('growl-container');
    const onFrame = () => {
        const scrollPos = window.parent.scrollY;
        element.style.top = `${scrollPos}px`;
        requestAnimationFrame(onFrame);
    };
    requestAnimationFrame(onFrame);
}
initGrowlContainer();
